import React, { useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { useAppSelector } from "../../app/hooks";
import { selectBackgroundTasks } from "./backgroundTasksSlice";
import AgentsSection from "../agents/AgentsSection";

export default function BackgroundTasksPanel() {
  const tasks = useAppSelector(selectBackgroundTasks);
  const [hovered, setHovered] = useState(false);

  //if (!tasks || tasks.length === 0) {
  //  return null;
  //}

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 140,
        left: 0,
        zIndex: 1400,
        display: "flex",
        alignItems: "flex-end",
        pointerEvents: "none",
      }}
    >
      {/* Side button that is always visible */}
      <Paper
        elevation={4}
        sx={{
          px: 0.8,
          py: 4,
          mr: 1,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "secondary.main",
          borderRadius: "0px",
          pointerEvents: "auto",
        }}
        onMouseEnter={() => setHovered(true)}
      >
        <Typography
          variant="caption"
          sx={{
            writingMode: "vertical-lr",
            transform: "rotate(180deg)",
            textOrientation: "mixed",
            fontSize: "14px",
            color: "white",
          }}
        >
          BACKGROUND
        </Typography>
      </Paper>

      {/* Slide-out tasks panel */}
      <Paper
        elevation={4}
        sx={{
          width: 300,
          maxHeight: 440,
          overflowY: "auto",
          p: 1,
          transform: hovered ? "translateX(0)" : "translateX(-100%)",
          opacity: hovered ? 1 : 0,
          pointerEvents: hovered ? "auto" : "none",
          transition: "transform 0.2s ease-out, opacity 0.2s ease-out",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <AgentsSection />
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          Background Tasks
        </Typography>
        <List dense>
          {tasks.map((task) => (
            <ListItem key={task.id}>
              <ListItemText
                primary={task.label}
                secondary={task.status}
                primaryTypographyProps={{ noWrap: true }}
                secondaryTypographyProps={{ noWrap: true }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
}

